<template>
  <el-row type="flex" class="web-wrapper">
    <el-header>
      <h3 class="title">
        <div class="block">
          <span>Web接入</span>
        </div>
      </h3>
    </el-header>
    <el-row type="flex" class="webhfive-addbox">
      <div class="webhfive-addbox-left">
        <el-scrollbar class="scrollbar-wrap">
          <div class="webhfive-addbox-con" id="webhfive-addbox-scroll">
            <div class="webhfive-addbox-title">
              <i></i>
              <span>网站接入基本配置</span>
            </div>
            <div class="webhfive-addbox-box">
              <el-form size="medium" label-width="160px" ref="configForm1" :model="configForm1" :rules="rules">
                <el-form-item label="网站名称" prop="name">
                  <el-input v-model="configForm1.name" placeholder="请输入网站名称" maxlength="20" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="网站域名" prop="webDomainName">
                  <el-input v-model="configForm1.webDomainName" placeholder="请输入网站域名" maxlength="60" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="启用智能机器人">
                  <el-radio-group v-model="configForm1.useRobot">
                    <el-radio :label="true">是</el-radio>
                    <el-radio :label="false">否</el-radio>
                  </el-radio-group>
                </el-form-item>
                <!-- <el-form-item label="启用智能机器人" prop="bot">
                <el-select v-model="configForm1.bot" placeholder="请选择">
                  <el-option
                    v-for="botInfo in botInfos"
                    :key="botInfo.id"
                    :label="botInfo.botName"
                    :value="botInfo.id"
                  ></el-option>
                </el-select>
              </el-form-item>-->
                <el-form-item label="欢迎语" prop="greeting">
                  <el-input type="textarea" v-model="configForm1.greeting" placeholder="请输入欢迎语，不超过240个字" maxlength="240"></el-input>
                </el-form-item>
                <el-form-item label="路由策略" prop="routeStrategy">
                  <el-select v-model="configForm1.routeStrategy" placeholder="请选择">
                    <el-option v-for="strategy in routeStrategyList" :key="strategy.id" :label="strategy.acdName" :value="strategy.id"></el-option>
                  </el-select>
                </el-form-item>
              </el-form>
            </div>
            <div class="webhfive-addbox-title" v-if="configForm1.useRobot">
              <i></i>
              <span>智能机器人配置</span>
            </div>
            <div class="webhfive-addbox-box" v-if="configForm1.useRobot">
              <el-form size="medium" label-width="160px" status-icon ref="configForm6" :model="configForm6" :rules="rules">
                <el-form-item label="机器人服务地址" prop="serviceAddress">
                  <el-input v-model="configForm6.serviceAddress" placeholder="请输入机器人服务地址" maxlength="200" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="机器人通讯地址" prop="socketAddress">
                  <el-input v-model="configForm6.socketAddress" placeholder="请输入机器人通讯地址" maxlength="200" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="机器人维度参数" prop="dimensionParam">
                  <div v-for="(item, index ) in configForm6.dimensionParam" :key="index">
                    <el-input v-model="item.dimKey" placeholder="请输入维度ID" :disabled="index === 0" style="width: 35%; margin-bottom: 5px;"></el-input>
                    <el-input v-model="item.tagId" placeholder="请输入TagID" :disabled="index === 0" style="width: 35%; margin-bottom: 5px;"></el-input>
                    <el-button type="text" v-if="index !== 0" @click="deleteDimensionParam(index)">
                      <svg class="icon icon-delete" aria-hidden="true">
                        <use xlink:href="#iconchahao" />
                      </svg>
                    </el-button>
                  </div>
                  <div v-if="configForm6.dimensionParam.length < 5">
                    <el-row>
                      <el-col :span="5">
                        <el-button type="primary" @click="addDimensionParam()">
                          <svg class="icon icon-bianji" aria-hidden="true">
                            <use xlink:href="#iconzengjia" />
                          </svg>
                        </el-button>
                      </el-col>
                      <el-col :span="2" :offset="2">
                        <el-button type="text">
                          <svg class="icon" aria-hidden="true">
                            <use xlink:href="#iconheadicon-help" />
                          </svg>
                        </el-button>
                      </el-col>
                      <el-col :span="15" style="line-height: 20px;">
                        <span>1.可添加多个渠道维度参数</span>
                        <p />
                        <span>2.相同维度只能添加一个参数</span>
                      </el-col>
                    </el-row>
                  </div>
                  <span v-if="configForm6RepetList.length > 0" style="color: red;">警告：存在重复维度参数设置！</span>
                </el-form-item>
              </el-form>
            </div>

            <!-- <div class="webhfive-addbox-title">
            <i class></i>
            <span>转人工配置</span>
          </div>
          <div class="webhfive-addbox-box">
            <el-form
              size="medium"
              label-width="160px"
              ref="configForm2"
              :model="configForm2"
              :rules="rules"
            >
              <el-form-item label="是否开启触发词命中转人工" prop="triggerOn">
                <el-radio-group v-model="configForm2.triggerOn">
                  <el-radio :label="true">是</el-radio>
                  <el-radio :label="false">否</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="转人工触发词" prop="triggerWord">
                <el-input placeholder="请输入您期望的触发词" v-model="configForm2.triggerWord"></el-input>
                <el-tooltip class="item" content placement="right">
                  <div slot="content">
                    1.可设置多个，多个触发词用英文逗号隔开。
                    <br />2.每个触发词需完全匹配才可触发。
                    <br />例如：触发词为”转人工“则必须输入”转人工“才能转入人工。
                  </div>
                  <el-button type="text" size="small">
                    <svg class="icon icon-warning" aria-hidden="true">
                      <use xlink:href="#icontixing" />
                    </svg>
                  </el-button>
                </el-tooltip>
              </el-form-item>
            </el-form>
          </div>-->
            <div class="webhfive-addbox-title">
              <i class></i>
              <span>对话窗口样式</span>
            </div>
            <div class="webhfive-addbox-box">
              <el-form label-width="160px" ref="configForm3" :model="configForm3" :rules="rules">
                <el-form-item label="窗口样式选择">
                  <el-radio-group v-model="configForm3.dialogStyle" @change="dialogStyleChange" class="radio-border">
                    <el-radio :label="'default'" border>
                      <img src="@/assets/images/channel/web/frame_1.jpg" />
                    </el-radio>
                    <el-radio :label="'right_wrap'" border>
                      <img src="@/assets/images/channel/web/frame_2.jpg" />
                    </el-radio>
                    <el-radio :label="'both_wrap'" border>
                      <img src="@/assets/images/channel/web/frame_3.jpg" />
                    </el-radio>
                    <el-radio :label="'left_wrap'" border>
                      <img src="@/assets/images/channel/web/frame_4.jpg" />
                    </el-radio>
                  </el-radio-group>
                </el-form-item>

                <el-form-item v-show="showBillBoard" label="企业宣传栏">
                  <el-upload :headers="headers" :action="imageUploadAction" :show-file-list="false" :on-success="handleBillboardSuccess" :before-upload="beforeUpload" accept="image/*">
                    <img v-if="billboardUrl" :src="billboardUrl" class="avatarImgCls" />
                    <el-button size="small" type="primary" v-if="!billboardUrl">
                      <svg class="icon" aria-hidden="true">
                        <use xlink:href="#icontupian" />
                      </svg>
                      点击上传图片
                    </el-button>
                    <div slot="tip" class="el-upload__tip">支持jpg/jpeg/png/gif格式，文件需小于1M</div>
                  </el-upload>
                </el-form-item>
                <el-form-item label="企业简称">
                  <el-input v-model="configForm3.companyAbbr" placeholder="请输入您的企业简称" maxlength="8" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="企业logo或头像">
                  <el-upload :headers="headers" :action="avatarUploadAction" :show-file-list="false" :on-success="handleCompanyAvatarSuccess" :before-upload="beforeUpload" accept="image/*">
                    <img v-if="companyAvatarUrl" :src="companyAvatarUrl" class="avatarImgCls" />
                    <el-button size="small" type="primary" v-if="!companyAvatarUrl">
                      <svg class="icon" aria-hidden="true">
                        <use xlink:href="#icontupian" />
                      </svg>
                      点击上传图片
                    </el-button>
                    <div slot="tip" class="el-upload__tip">支持jpg/jpeg/png/gif格式，文件需小于1M</div>
                  </el-upload>
                </el-form-item>
                <el-form-item label="系统消息头像">
                  <el-upload :headers="headers" :action="avatarUploadAction" :show-file-list="false" :on-success="handleMessageAvatarSuccess" :before-upload="beforeUpload" accept="image/*">
                    <img v-if="messageAvatarUrl" :src="messageAvatarUrl" class="avatarImgCls" />
                    <el-button size="small" type="primary" v-if="!messageAvatarUrl">
                      <svg class="icon" aria-hidden="true">
                        <use xlink:href="#icontupian" />
                      </svg>
                      点击上传图片
                    </el-button>
                    <div slot="tip" class="el-upload__tip">支持jpg/jpeg/png/gif格式，文件需小于1M</div>
                  </el-upload>
                </el-form-item>
                <el-form-item label="对话框皮肤">
                  <template v-for="color in colorList">
                    <el-radio-group v-model="configForm3.skinColor" :key="color.name" class="radio-group-skin">
                      <el-radio :label="color.name" :class="color.type"></el-radio>
                    </el-radio-group>
                  </template>
                  <el-row type="flex" style="margin-top: 10px">
                    <el-color-picker class="blue" v-model="configForm3.skinColor"></el-color-picker>
                    <el-input v-model="configForm3.skinColor" style="width: 90px;margin-left: 10px"></el-input>
                  </el-row>
                </el-form-item>
                <el-form-item label="是否显示关闭按钮">
                  <el-radio-group v-model="configForm3.showCloseBtn">
                    <el-radio :label="true">是</el-radio>
                    <el-radio :label="false">否</el-radio>
                  </el-radio-group>
                </el-form-item>
                <!-- <el-form-item label="转人工按钮是否显示">
                <el-radio-group v-model="configForm3.showTransferBtn">
                  <el-radio :label="true">是</el-radio>
                  <el-radio :label="false">否</el-radio>
                </el-radio-group>
              </el-form-item>-->
              </el-form>
            </div>
            <div class="webhfive-addbox-title">
              <i class></i>
              <span>对话框位置及大小</span>
            </div>
            <div class="webhfive-addbox-box">
              <el-form size="medium" label-width="160px" ref="configForm4" :model="configForm4">
                <el-form-item label="水平方向">
                  <el-row type="flex" justify="space-between">
                    <el-col :span="9">
                      <el-select v-model="configForm4.horizontalAlign" style="text-align: center; text-align-last: center;">
                        <el-option v-for="horAlign in horizontalAlignGroup" :key="horAlign.value" :label="horAlign.label" :value="horAlign.value"></el-option>
                      </el-select>
                    </el-col>
                    <!-- <el-col :span="14" class="form-item-complex">
                    <el-row type="flex">
                      <el-input-number
                        v-model="configForm4.horizontalOffset"
                        controls-position="right"
                        :max="1000"
                        :min="0"
                        :step="10"
                        step-strictly
                      ></el-input-number>
                      <el-button>像素</el-button>
                    </el-row>
                  </el-col> -->
                  </el-row>
                </el-form-item>
                <el-form-item label="垂直方向">
                  <el-row type="flex" justify="space-between">
                    <el-col :span="9">
                      <el-select v-model="configForm4.verticalAlign" style="text-align: center; text-align-last: center;">
                        <el-option v-for="verAlign in verticalAlignGroup" :key="verAlign.value" :label="verAlign.label" :value="verAlign.value"></el-option>
                      </el-select>
                    </el-col>
                    <!-- <el-col :span="14" class="form-item-complex">
                    <el-row type="flex">
                      <el-input-number
                        v-model="configForm4.verticalOffset"
                        controls-position="right"
                        :max="1000"
                        :min="0"
                        :step="10"
                        step-strictly
                      ></el-input-number>
                      <el-button>像素</el-button>
                    </el-row>
                  </el-col> -->
                  </el-row>
                </el-form-item>
                <el-form-item label="宽度">
                  <el-row type="flex" class="form-item-complex">
                    <el-input-number v-model="configForm4.width" controls-position="right" :min="dialogMinWidth" :step="10" step-strictly></el-input-number>
                    <el-button>像素</el-button>
                  </el-row>
                  <div class="sub-title">建议范围：700~1000像素</div>
                </el-form-item>
                <el-form-item label="高度">
                  <el-row type="flex" class="form-item-complex">
                    <el-input-number v-model="configForm4.height" controls-position="right" :min="500" :step="10" step-strictly></el-input-number>
                    <el-button>像素</el-button>
                  </el-row>
                  <div class="sub-title">建议范围：600~800像素</div>
                </el-form-item>
              </el-form>
            </div>
            <div class="webhfive-addbox-title">
              <i class></i>
              <span>在线咨询网站按钮样式</span>
            </div>
            <div class="webhfive-addbox-box">
              <el-form size="medium" label-width="160px" :model="configForm5" ref="configForm5" :rules="rules">
                <el-form-item label="是否隐藏侧边栏默认按钮">
                  <el-radio-group v-model="configForm5.hideSidebarBtn">
                    <el-radio :label="true">是</el-radio>
                    <el-radio :label="false">否</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="在线咨询按钮文案">
                  <el-input v-model="configForm5.openBtnText" placeholder="在线咨询" maxlength="6" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="图标选择">
                  <ul class="webhfive-addbox-ul">
                    <li v-for="iconCls in openBtnIcons" :key="iconCls" :class="{active:iconCls===activatedIconCls}" @click="changeOpenBtnIcon(iconCls)">
                      <svg class="icon icon-tips" aria-hidden="true">
                        <use :xlink:href="iconCls" />
                      </svg>
                    </li>
                  </ul>
                </el-form-item>
                <!-- <el-form-item label="按钮垂直方向">
                <el-col :span="9">
                  <el-select
                    v-model="configForm5.openBtnVerticalAlign"
                    style="text-align: center; text-align-last: center;"
                  >
                    <el-option
                      v-for="verAlign in verticalAlignGroup"
                      :key="verAlign.value"
                      :label="verAlign.label"
                      :value="verAlign.value"
                    ></el-option>
                  </el-select>
                </el-col>
              </el-form-item> -->
                <el-form-item label="侧边距">
                  <el-row type="flex" class="form-item-complex">
                    <el-input-number v-model="configForm5.openBtnHorizontalOffset" controls-position="right" :max="1000" :min="0" :step="10" step-strictly></el-input-number>
                    <el-button>像素</el-button>
                  </el-row>
                </el-form-item>
                <el-form-item label="顶边距">
                  <el-row type="flex" class="form-item-complex">
                    <el-input-number v-model="configForm5.openBtnVerticalOffset" controls-position="right" :max="1000" :min="-1000" :step="10" step-strictly></el-input-number>
                    <el-button>像素</el-button>
                  </el-row>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-scrollbar>
        <el-row class="webhfive-addbox-btnbox" type="flex" justify="center">
          <el-button size="medium" @click="goBack">返 回</el-button>
          <el-button type="primary" size="medium" @click="saveConfig" :loading="saveBtnLoading">保存设置</el-button>
        </el-row>
      </div>
      <div class="webhfive-addbox-right">
        <div class="webhfive-addbox-title" style="margin-right: 0">
          <i class></i>
          <span>预览效果</span>
        </div>
        <div class="webhfive-addbox-rightcon">
          <p>由于预览区域的大小限制，无法完全按照您网站的尺寸进行预览展示，如有需要，请保存设置后，在真实的网站中进行效果预览。</p>
          <div class="addbox-wrapper">
            <div class="webhfive-addbox-dialog"
                 :class="{'horizontal-left': configForm4.horizontalAlign === 'left',  'horizontal-center': configForm4.horizontalAlign === 'center',  'horizontal-right': configForm4.horizontalAlign === 'right', 'vertical-top': configForm4.verticalAlign === 'top',  'vertical-center': configForm4.verticalAlign === 'center',  'vertical-bottom': configForm4.verticalAlign === 'bottom', 'hv-center': configForm4.verticalAlign === 'center' && configForm4.horizontalAlign === 'center'}">
              <div class="dialog-top" :style="{'backgroundColor':  configForm3.skinColor}">
                <!-- <a href="javaScript:;">
                  <svg class="icon icon-tips" aria-hidden="true">
                    <use xlink:href="#iconxiaoxi" />
                  </svg>
                </a>-->
                <a href="javaScript:;">
                  <svg class="icon icon-tips" aria-hidden="true">
                    <use xlink:href="#iconjianshao" />
                  </svg>
                </a>
                <a v-show="configForm3.showCloseBtn" href="javaScript:;">
                  <svg class="icon iconclose icon-tips" aria-hidden="true">
                    <use xlink:href="#iconclose" />
                  </svg>
                </a>
              </div>
              <div class="dialog-content">
                <div v-show="leftWrap" class="left-wrap">
                  <img src="@/assets/images/pic-place.png" alt />
                </div>
                <div class="center-wrap" style="width:230px;">
                  <div class="dialog-center">
                    <div class="dialog-center-bfb">
                      <div class="dialog-center-ico dialog-center-ico-clolor1">
                        <svg class="icon" aria-hidden="true">
                          <use xlink:href="#iconmenuicon-kehu" />
                        </svg>
                      </div>
                      <div class="dialog-center-box">
                        <div class="dialog-center-timetxt">
                          <span class="dialog-center-name dialog-center-mr10">Sam</span>
                          <span class="dialog-center-date">03月24日</span>
                        </div>
                        <div class="dialog-center-txt dialog-center-txt-clolor1">我的信用卡丢了</div>
                      </div>
                    </div>
                    <div class="dialog-center-bfb" style="justify-content: flex-end">
                      <div class="dialog-center-box">
                        <div class="dialog-center-timetxt" style="text-align: right">
                          <span class="dialog-center-date dialog-center-mr10">03月24日</span>
                          <span class="dialog-center-name">小燕</span>
                        </div>
                        <div class="dialog-center-txt dialog-center-txt-clolor2 dialog-center-txtwhite" :style="{backgroundColor:  configForm3.skinColor, '--color':  configForm3.skinColor}">请问您是否需要挂失信用卡</div>
                      </div>
                      <div class="dialog-center-ico dialog-center-ico-clolor2" :style="{backgroundColor:  configForm3.skinColor}">
                        <svg class="icon" aria-hidden="true">
                          <use xlink:href="#iconheadicon-zuoxi" />
                        </svg>
                      </div>
                    </div>
                  </div>
                  <div class="dialog-bottom">
                    <div class="dialog-bottom-ico1">
                      <svg class="icon" aria-hidden="true">
                        <use xlink:href="#iconbiaoqing" />
                      </svg>
                    </div>
                    <div class="dialog-bottom-sendout">
                      <svg class="icon" aria-hidden="true" :style="{color:  configForm3.skinColor}">
                        <use xlink:href="#iconfasong" />
                      </svg>
                    </div>
                  </div>
                </div>
                <div v-show="rightWrap" class="right-wrap">
                  <img src="@/assets/images/pic-place.png" alt />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-row>
  </el-row>
</template>

<script>
import { insertConfig, updateConfig, getConfigById, getWebStrategies } from '@/api/channel/web.js'

export default {
  name: 'AddWeb',
  data() {
    var dimensionParamValidate = (rule, value, callback) => {
      this.configForm6RepetList = []
      if (value.length > 0) {
        var keyList = []
        value.forEach(item => {
          const key = item.dimKey
          if (keyList.includes(key)) {
            this.configForm6RepetList.push(key)
          } else {
            keyList.push(key)
          }
        })
      }
      callback()
    }
    return {
      saveBtnLoading: false,
      billboardUrl: '',
      companyAvatarUrl: '',
      messageAvatarUrl: '',
      // 一、配置表单
      // --(1)网站接入基本配置
      configForm1: {
        platformId: 'web', // 固定值,不需要改动
        id: '',
        webStyleId: '', // web样式表关联外键id
        name: '',
        webDomainName: '',
        useRobot: false,
        bot: '',
        greeting: '',
        routeStrategy: ''
      },
      // 转人工配置
      configForm2: {
        triggerOn: true,
        triggerWord: '转人工,人工客服,人工服务'
      },
      // 对话窗口样式
      configForm3: {
        dialogStyle: 'default', // default/right_wrap/both_wrap/left_wrap
        billboardImgPath: '',
        companyAbbr: '',
        companyAvatarImgPath: '',
        messageAvatarImgPath: '',
        skinColor: '#409EFF',
        showCloseBtn: true
        // showTransferBtn: true //转人工按钮是否显示(暂时去除)
      },
      // 对话框位置及大小
      configForm4: {
        horizontalAlign: 'center',
        horizontalOffset: 0, // 暂时用不到，默认值设置为0
        verticalAlign: 'center',
        verticalOffset: 0, // 暂时用不到，默认值设置为0
        width: 800,
        height: 600
      },
      // 在线咨询网站按钮样式
      configForm5: {
        hideSidebarBtn: false,
        openBtnText: '在线咨询',
        openBtnIcon: '#icontalk-1',
        openBtnVerticalAlign: 'center',
        openBtnHorizontalOffset: 20,
        openBtnVerticalOffset: 0
      },
      // 智能机器人配置
      configForm6: {
        serviceAddress: '',
        socketAddress: '',
        dimensionParam: [
          { dimKey: 'platform', tagId: 'web' }
        ]
      },
      configForm6RepetList: [],
      // 智能机器人下拉框数据(来自后端接口)
      botInfos: [{
        id: 'robotuuid1',
        botName: '初代原型机'
      }, {
        id: 'robotuuid2',
        botName: '进化者2号'
      }, {
        id: 'robotuuid3',
        botName: '进化者3号'
      }],
      // 路由策略下拉框数据(来自后端接口)
      routeStrategyList: [],
      // 对话框水平方向布局选项下拉框
      horizontalAlignGroup: [
        {
          value: 'left',
          label: '向左对齐'
        },
        {
          value: 'center',
          label: '居中对齐'
        },
        {
          value: 'right',
          label: '向右对齐'
        }
      ],
      // 对话框垂直方向布局选项下拉框
      verticalAlignGroup: [
        {
          value: 'top',
          label: '顶部对齐'
        },
        {
          value: 'center',
          label: '居中对齐'
        },
        {
          value: 'bottom',
          label: '底部对齐'
        }
      ],
      // 选中的icon样式
      activatedIconCls: '#icontalk-1',
      // 咨询按钮icon样式
      openBtnIcons: ['#icontalk-1', '#icontalk-2', '#icontalk-3', '#icontalk-4', '#icontalk-5', '#icontalk-6', '#icontalk-7'],
      // 皮肤颜色样式
      colorList: [{ name: '#2db7f5', type: 'blue' }, { name: '#67c23a', type: 'green' }, { name: '#f56c6c', type: 'pink' }, { name: '#ffa902', type: 'yellow' }, { name: '#00cccd', type: 'skyblue' }, { name: '#aace06', type: 'lime' }, { name: '#e03e74', type: 'hotpink' }],
      // 企业广告牌(宣传牌)相关3参数
      showBillBoard: false,
      leftWrap: false,
      rightWrap: false,
      // 表单校验规则
      rules: {
        name: [
          { required: true, message: '请输入网站名称', trigger: 'blur' }
        ],
        webDomainName: [
          { required: true, message: '请输入网站域名', trigger: 'blur' }
        ],
        bot: [
          { required: true, message: '请选择机器人', trigger: 'change' }
        ],
        greeting: [
          { required: true, message: '请输入欢迎语', trigger: 'blur' }
        ],
        routeStrategy: [
          { required: true, message: '请输入路由策略', trigger: 'change' }
        ],
        triggerWord: [
          { required: true, message: '请输入触发关键词', trigger: 'blur' }
        ],
        serviceAddress: [
          { required: true, message: '请输入机器人服务地址', trigger: 'blur' }
        ],
        socketAddress: [
          { required: true, message: '请输入机器人通讯地址', trigger: 'blur' }
        ],
        dimensionParam: [
          { validator: dimensionParamValidate, trigger: 'blur' }
        ]
      }
    }
  },
  mounted() {
    // 加载路由策略下拉框
    this.getWebStrategiesList()
    // 如果是编辑,就回显数据
    if (this.$parent.currentChannelInfoId) {
      this.getConfig()
    }
  },
  computed: {
    // 上传文件的额外请求头
    headers: function () {
      const cTenantId = localStorage.getItem('X-TENANT-ID')
      return { 'X-TENANT-ID': cTenantId }
    },
    // 图片上传接口地址（永久保存，非临时 isTemp=false）
    imageUploadAction: function () {
      return window.$envUtils('VUE_APP_BASE_URL') + window.$envUtils('VUE_APP_BP_SERVICE') + '/res/upload/file?fileType=0&isTemp=false'
    },
    // 头像图片上传接口地址（永久保存，非临时 isTemp=false）
    avatarUploadAction: function () {
      return window.$envUtils('VUE_APP_BASE_URL') + window.$envUtils('VUE_APP_BP_SERVICE') + '/res/upload/file?fileType=6&isTemp=false'
    },
    // 图片下载/回显接口地址
    imageDownloadAction: function () {
      return window.$envUtils('VUE_APP_BASE_URL') + window.$envUtils('VUE_APP_BP_SERVICE') + '/res/download'
    },
    // 对话框最小宽度要求
    dialogMinWidth: function () {
      if (this.configForm3.dialogStyle === 'both_wrap') {
        return 900
      } else if (this.configForm3.dialogStyle === 'left_wrap' || this.configForm3.dialogStyle === 'right_wrap') {
        return 700
      } else {
        return 500
      }
    }
  },
  methods: {
    // 查询/回显配置信息
    getConfig() {
      getConfigById({ id: this.$parent.currentChannelInfoId }).then(res => {
        const baseConfig = res.baseConfig
        const styleConfig = res.styleConfig
        // 回显基本配置
        // -- (1)基本配置
        this.configForm1.id = baseConfig.id
        this.configForm1.name = baseConfig.name
        this.configForm1.webDomainName = baseConfig.webDomainName
        this.configForm1.useRobot = baseConfig.useRobot
        this.configForm1.bot = baseConfig.bot
        this.configForm1.greeting = baseConfig.greeting
        this.configForm1.routeStrategy = baseConfig.routeStrategy
        this.configForm1.webStyleId = baseConfig.webStyleId // web样式id
        // -- (2)转人工配置
        this.configForm2.triggerOn = baseConfig.triggerOn
        this.configForm2.triggerWord = baseConfig.triggerWord
        // 智能机器人配置
        if (baseConfig.useRobot) {
          this.configForm6.serviceAddress = baseConfig.robotServiceAddress
          this.configForm6.socketAddress = baseConfig.robotSocketAddress
          const robotDimParam = JSON.parse(baseConfig.robotDimParam)
          this.configForm6.dimensionParam = robotDimParam === null ? [{ dimKey: 'platform', tagId: 'web' }] : robotDimParam
        }
        // 回显样式配置
        // --(3)对话窗口样式
        this.configForm3.companyAbbr = styleConfig.companyAbbr
        this.configForm3.dialogStyle = styleConfig.dialogStyle
        // 手动触发一下预览框回显方法
        this.dialogStyleChange(styleConfig.dialogStyle)
        this.configForm3.billboardImgPath = styleConfig.billboardImgPath
        this.configForm3.companyAbbr = styleConfig.companyAbbr
        this.configForm3.companyAvatarImgPath = styleConfig.companyAvatarImgPath
        this.configForm3.messageAvatarImgPath = styleConfig.messageAvatarImgPath
        this.configForm3.skinColor = styleConfig.skinColor
        this.configForm3.showCloseBtn = styleConfig.showCloseBtn
        this.configForm3.showTransferBtn = styleConfig.showTransferBtn
        // 如果返回的图片路径存在,就进行回显
        if (styleConfig.billboardImgPath) {
          this.billboardUrl = this.imageDownloadAction + styleConfig.billboardImgPath
        }
        if (styleConfig.companyAvatarImgPath) {
          this.companyAvatarUrl = this.imageDownloadAction + styleConfig.companyAvatarImgPath
        }
        if (styleConfig.messageAvatarImgPath) {
          this.messageAvatarUrl = this.imageDownloadAction + styleConfig.messageAvatarImgPath
        }

        // --(4)对话框位置及大小
        this.configForm4.horizontalAlign = styleConfig.horizontalAlign
        this.configForm4.horizontalOffset = styleConfig.horizontalOffset
        this.configForm4.verticalAlign = styleConfig.verticalAlign
        this.configForm4.verticalOffset = styleConfig.verticalOffset
        this.configForm4.width = styleConfig.width
        this.configForm4.height = styleConfig.height
        // --(5)在线咨询网站按钮样式
        this.configForm5.hideSidebarBtn = styleConfig.hideSidebarBtn
        this.configForm5.openBtnText = styleConfig.openBtnText
        this.configForm5.openBtnIcon = styleConfig.openBtnIcon
        // 手动触发一下icon按钮change事件
        this.changeOpenBtnIcon(styleConfig.openBtnIcon)
        this.configForm5.openBtnVerticalAlign = styleConfig.openBtnVerticalAlign
        this.configForm5.openBtnHorizontalOffset = styleConfig.openBtnHorizontalOffset
        this.configForm5.openBtnVerticalOffset = styleConfig.openBtnVerticalOffset
      }).catch(err => {
        this.$message.error(err)
      })
    },
    // 返回主页面的方法
    goBack() {
      this.$parent.changeView('webList')
      this.resetConfig()
    },
    // 企业广告牌的上传成功后的处理
    handleBillboardSuccess(res, file) {
      // 返回的response是图片文件在服务器指定文件夹下的相对路径,与下载路径拼接后即可回显图片
      // 回显方式有两种(一种是利用element组件封装的blob对象,一种则是与返回的下载路径拼接,利用后端下载接口重新下载图片),两种方式都贴出来,但实际采用前一种方式,回显更快,开销更小
      // this.billboardUrl = this.imageDownloadAction + res.url
      this.billboardUrl = URL.createObjectURL(file.raw)
      // 给配置表赋值,用于保存时记录到数据库
      this.configForm3.billboardImgPath = res.url
    },
    // 企业logo头像上传成功后的处理
    handleCompanyAvatarSuccess(res, file) {
      // this.companyAvatarUrl = this.imageDownloadAction + res.url
      this.companyAvatarUrl = URL.createObjectURL(file.raw)
      this.configForm3.companyAvatarImgPath = res.url
    },
    // 系统消息头像上传成功后的处理
    handleMessageAvatarSuccess(res, file) {
      // this.messageAvatarUrl = this.imageDownloadAction + res.url
      this.messageAvatarUrl = URL.createObjectURL(file.raw)
      this.configForm3.messageAvatarImgPath = res.url
    },
    beforeUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 1
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 1MB!')
      }
      return isLt2M
    },

    // 在线咨询按钮样式--选中图标改变事件
    changeOpenBtnIcon(iconCls) {
      this.configForm5.openBtnIcon = iconCls
      this.activatedIconCls = iconCls
    },

    // 重置配置的方法
    resetConfig() {
      this.$parent.currentChannelInfoId = ''
    },
    // 保存配置的方法
    saveConfig() {
      // 1.企业宣传栏图片不能为空
      if (this.configForm3.dialogStyle !== 'default') {
        if (!this.configForm3.billboardImgPath) {
          this.$message.warning('上传图片不能为空!')
          return
        }
      }
      // 2.头像和logo图片不能为空
      if (!this.configForm3.companyAvatarImgPath || !this.configForm3.messageAvatarImgPath) {
        this.$message.warning('上传图片不能为空!')
        return
      }
      // 3.多表单校验(当前只有configForm1和2需要校验)
      const valid1 = new Promise((resolve, reject) => {
        this.$refs.configForm1.validate(valid => {
          if (valid) {
            resolve()
          }
        })
      })
      // 4.机器人维度参数校验
      if (this.configForm1.useRobot) {
        this.configForm6.dimensionParam = this.configForm6.dimensionParam.filter(each => each.dimKey.trim() !== '')
        this.$refs.configForm6.validate()
        if (this.configForm6RepetList.length > 0) {
          this.$message.warning('存在重复的机器人维度设置！')
          return
        }
      }
      // const valid2 = new Promise((resolve, reject) => {
      //   this.$refs.configForm2.validate(valid => {
      //     if (valid) {
      //       resolve()
      //     }
      //   })
      // })
      // 所有表单均校验通过,才执行save逻辑
      Promise.all([valid1/*, valid2 */]).then(() => {
        // 预处理表单参数
        const configs = {
          ...this.configForm1,
          ...this.configForm2,
          ...this.configForm3,
          ...this.configForm4,
          ...this.configForm5,
          ...this.configForm6
        }
        // 判断是新增还是修改
        if (!this.$parent.currentChannelInfoId) {
          // 新增的逻辑
          this.saveBtnLoading = true // 开启按钮加载动画
          insertConfig(configs).then(res => {
            this.saveBtnLoading = false// 关闭按钮加载动画
            // 切换页面到列表页
            this.$message.success('保存成功!')
            this.$parent.changeView('webList')
            this.resetConfig()
          }).catch(err => {
            this.saveBtnLoading = false// 关闭按钮加载动画
            this.$message.error(err)
          })
        } else {
          // 修改的逻辑
          updateConfig(configs).then(res => {
            // 切换页面到列表页
            this.$message.success('保存成功!')
            this.$parent.changeView('webList')
            this.resetConfig()
          })
        }
      })
    },
    // 获取路由策略下拉框数据
    getWebStrategiesList() {
      getWebStrategies().then(res => {
        if (res.data && res.data.length > 0) {
          this.routeStrategyList = res.data
        }
      })
    },
    // 对话框样式改变事件
    dialogStyleChange(value) {
      if (value === 'default') {
        this.leftWrap = false
        this.rightWrap = false
        this.showBillBoard = false
      } else if (value === 'right_wrap') {
        this.leftWrap = false
        this.rightWrap = true
        this.showBillBoard = true
      } else if (value === 'both_wrap') {
        this.leftWrap = true
        this.rightWrap = true
        this.showBillBoard = true
      } else if (value === 'left_wrap') {
        this.leftWrap = true
        this.rightWrap = false
        this.showBillBoard = true
      }
    },
    // 删除机器人维度参数
    deleteDimensionParam(index) {
      this.configForm6.dimensionParam.splice(index, 1)
      this.$refs.configForm6.validate()
    },
    // 添加机器人维度参数
    addDimensionParam() {
      this.configForm6.dimensionParam.push({ dimKey: '', tagId: '' })
    }
  }
}
</script>
<style lang="scss" scoped>
.web-wrapper {
  height: calc(100vh - 76px);
  flex-direction: column;
}
.el-header {
  height: auto !important;
  margin-bottom: 0;
  padding: 0;
  .title {
    margin-bottom: 20px;
  }
}
.webhfive-addbox {
  height: calc(100% - 70px);
  /*width: auto;
  height: auto;
  position: absolute;
  top: 91px;
  bottom: 0;
  left: 0px;
  right: 0;*/
  .webhfive-addbox-title {
    background-color: #f5f5f5;
    height: 38px;
    line-height: 38px;
    font-size: 16px;
    margin-right: 10px;
    i {
      width: 3px;
      height: 14px;
      border-radius: 1px;
      display: inline-block;
      background-color: #337eff;
      margin: 13px 17px 0 0;
    }
  }

  .webhfive-addbox-left {
    position: relative;
    width: 58%;
    height: 100%;
    border-right: 1px solid #e1e3e6;
    .scrollbar-wrap {
      height: calc(100% - 70px);
    }
    .webhfive-addbox-con {
      width: auto;
      /* position: absolute;
      bottom: 71px;
      top: 0;
      left: 20px;
      right: 0;*/
      /*overflow-y: auto;*/
      /*padding-bottom: 70px;*/
      .webhfive-addbox-box {
        width: 100%;
        padding-top: 20px;
        padding-left: 20px;
        height: auto;
        margin-bottom: 20px;
        &:nth-child(1) {
          margin: 0;
        }

        ::v-deep .el-form-item {
          .el-form-item__error {
            padding-top: 2px;
          }
        }

        .webhfive-addbox-inputbox {
          margin-bottom: 15px;
          width: 100%;
          .webhfive-addbox-span {
            width: 160px;
            line-height: 36px;
            padding-left: 20px;
            font-size: 12px;
            color: #333;
          }

          .tips-wrapper {
            margin: 10px 0 0 10px;
          }
        }

        .icon-addbox {
          width: 18px;
          height: 18px;
          border: 1px solid #cfd5db;
          background-color: #f4f4f5;
          border-radius: 2px;
          text-align: center;
          cursor: pointer;
          &:hover {
            background-color: #409eff;
            border: 1px solid #409eff;
            .icon {
              color: #fff;
            }
          }

          .icon {
            color: #cfd5db;
          }
        }

        .webhfive-addbox-inline {
          width: 210px;
          display: inline-block;
          float: none;
        }

        .webhfive-addbox-center {
          align-self: center;
          margin-left: 10px;
          margin-top: 10px;
        }

        .webhfive-addbox-width {
          width: 100%;
          float: left;
          margin-top: 10px;
          &:nth-child(1) {
            margin: 0;
          }
        }

        .webhfive-addbox-width170 {
          width: 170px;
        }

        .webhfive-addbox-width390 {
          width: 390px;
        }

        .webhfive-addbox-ul {
          display: flex;
          margin-top: 5px;
          li {
            width: 26px;
            height: 26px;
            text-align: center;
            background-color: #e5e5e5;
            border-radius: 2px;
            margin-right: 10px;
            margin-bottom: 5px;
            cursor: pointer;
            border: none;
            .icon {
              vertical-align: inherit;
              font-size: 16px;
              color: #7f7f7f;
            }
            &:hover {
              background-color: #3fbeff;
              .icon {
                color: #fff;
              }
            }
            &.active {
              background-color: #3fbeff;
              .icon {
                color: #fff;
              }
            }
          }
        }
      }
    }

    .webhfive-addbox-btnbox {
      position: absolute;
      z-index: 2;
      bottom: 0;
      left: -20px;
      right: 0;
      border-top: 1px solid #ebebeb;
      background-color: #fff;
      text-align: center;
      padding-top: 15px;
      padding-bottom: 15px;
      box-shadow: 0px -3px 5px rgba(200, 200, 200, 0.4);
    }
  }

  .webhfive-addbox-right {
    /* position: absolute;
    left: 610px;
    top: 0;
    right: 20px;*/
    width: 42%;
    padding-left: 10px;
    .webhfive-addbox-rightcon {
      background-color: #fff;
      border: 1px solid #e1e3e6;
      box-sizing: border-box;
      width: 100%;
      p {
        padding: 15px 20px;
        color: #8093af;
        font-size: 14px;
        line-height: 20px;
      }

      .addbox-wrapper {
        position: relative;
        min-height: 400px;
        overflow-x: auto;
      }
      .webhfive-addbox-dialog {
        display: flex;
        flex-direction: column;
        position: absolute;
        left: 10px;
        bottom: 10px;
        height: 260px;
        box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.1);
        &.width-md {
          width: 390px;
        }
        &.horizontal-left {
          left: 10px;
          right: inherit;
        }
        &.horizontal-center {
          left: 50%;
          right: inherit;
          transform: translateX(-50%);
        }
        &.horizontal-right {
          right: 10px;
          left: inherit;
        }
        &.vertical-top {
          top: 10px;
          bottom: inherit;
        }
        &.vertical-center {
          top: 45%;
          bottom: inherit;
          transform: translateY(-50%);
        }
        &.vertical-bottom {
          bottom: 10px;
          top: inherit;
        }
        &.hv-center {
          transform: translate(-50%, -50%);
        }

        .dialog-top {
          display: flex;
          justify-content: flex-end;
          background-color: #ffa902;
          width: 100%;
          height: 42px;
          line-height: 42px;
          border-radius: 4px 4px 0 0;
          a {
            margin-right: 10px;
            .icon {
              color: #fff;
            }
          }
        }

        .dialog-content {
          display: flex;
          flex: 1;
          .left-wrap,
          .right-wrap {
            width: 80px;
            height: 100%;
            overflow: hidden;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .left-wrap {
            border-radius: 0 0 0 4px;
          }
          .right-wrap {
            border-radius: 0 0 4px 0;
          }
          .center-wrap {
            display: flex;
            flex-direction: column;
            width: 230px;
            .dialog-center {
              flex: 1;
              background-color: #fff;
              width: 100%;
              border-left: 1px solid #dcdfe6;
              border-right: 1px solid #dcdfe6;
              box-sizing: border-box;
              overflow-y: auto;
              /*position: absolute;
              left: 0;
              top: 42px;
              bottom: 58px;
              right: 0;*/
              .dialog-center-bfb {
                display: flex;
                width: 100%;
                margin-top: 10px;
              }

              .dialog-center-ico {
                width: 30px;
                height: 30px;
                text-align: center;
                border-radius: 50%;
                box-sizing: border-box;
              }

              .dialog-center-ico-clolor1 {
                background-color: #cbd4de;
                margin: 17px 12px 0 6px;
                padding-top: 6px;
                .icon {
                  color: #fff;
                  font-size: 16px;
                }
              }

              .dialog-center-txt-clolor1 {
                background-color: #f0f0f0;
                color: #333 !important;
                &:after {
                  left: -12px;
                  top: 8px;
                  border-color: transparent #f0f0f0 transparent transparent;
                }
              }

              .dialog-center-ico-clolor2 {
                background-color: #ffa902;
                margin: 17px 6px 0 12px;
                padding-top: 5px;
                .icon {
                  color: #fff;
                  font-size: 20px;
                }
              }

              .dialog-center-txt-clolor2 {
                background-color: #ffa902;
                &:after {
                  right: -12px;
                  top: 8px;
                  border-color: transparent transparent transparent var(--color);
                }
              }

              .dialog-center-box {
                max-width: 50%;
                width: auto;
              }

              .dialog-center-name {
                font-size: 12px;
                color: #000;
              }

              .dialog-center-mr10 {
                margin-right: 10px;
              }

              .dialog-center-txtwhite {
                color: #fff !important;
              }

              .dialog-center-date {
                font-size: 12px;
                color: #ccc;
              }

              .dialog-center-txt {
                width: auto;
                position: relative;
                padding: 5px 10px;
                border-radius: 4px;
                line-height: 20px;
                margin-top: 2px;
                font-size: 12px;

                &:after {
                  content: "";
                  position: absolute;
                  width: 0;
                  height: 0;
                  border-width: 6px;
                  border-style: solid;
                }
              }
            }
            .dialog-bottom {
              background-color: #fff;
              width: 100%;
              height: 58px;
              border: 1px solid #dcdfe6;
              box-sizing: border-box;
              position: relative;
              /*position: absolute;
              bottom: 0;
              left: 0;*/
              .dialog-bottom-ico1 {
                margin: 5px 0 0 5px;
                .icon {
                  color: #97a1ac;
                  font-size: 16px;
                }
              }

              .dialog-bottom-sendout {
                position: absolute;
                right: 5px;
                bottom: 7px;
                cursor: pointer;
                .icon {
                  color: #ffa902;
                  font-size: 16px;
                }
              }
            }
          }
        }
      }
    }
  }
}
.el-form {
  /* display: flex;
  align-items: center;
  justify-content: space-between;*/

  .el-form-item {
    margin-bottom: 15px;
    ::v-deep .el-form-item__label {
      font-size: 12px;
      color: #333;
      text-align: left;
    }
    ::v-deep .el-form-item__content {
      .form-item-line {
        display: flex;
        margin-bottom: 12px;
        .el-button {
          margin-left: 10px;
        }
      }

      .el-input,
      .el-textarea,
      .el-select {
        width: 80%;
        margin-right: 10px;
        font-size: 12px;
      }
      .el-select {
        .el-input {
          width: 100%;
        }
      }

      .el-row {
        width: 80%;
        .el-input,
        .el-textarea,
        .el-select {
          width: 100%;
          margin-right: 0;
        }
      }

      .sub-title {
        margin-top: 5px;
        color: #999;
        line-height: 1.4;
      }

      .el-upload {
        margin-top: 3px;
        .el-button {
          padding: 0;
          border: 1px solid transparent;
          background-color: transparent;
          color: #337eff;
          > * {
            display: flex;
            align-items: center;

            .icon {
              font-size: 34px;
              color: #99a3ae;
            }
          }
        }
      }
      .el-upload__tip {
        margin-top: -15px;
        margin-bottom: 5px;
        color: #999;
        line-height: 1.4;
      }
    }
  }
  .form-item-complex {
    .el-row {
      width: 100% !important;
    }
    ::v-deep .el-input-number {
      .el-input-number__increase,
      .el-input-number__decrease {
        width: 20px;
        border-radius: 4px 0 0 4px;
      }
      .el-input {
        width: 100%;
        .el-input__inner {
          padding-right: 30px;
          border-radius: 4px 0 0 4px;
        }
      }
    }
    .el-button {
      font-size: 12px;
      border: 1px solid #dcdfe6;
      background-color: #f5f5f5;
      border-radius: 0 4px 4px 0;
      border-left: none;
      cursor: default;

      &:hover,
      &:active,
      &:focus {
        border-color: #dcdfe6;
        color: #333;
      }
    }
  }
  .el-button {
    & + .el-button {
      margin-left: 10px;
    }
  }
}
.mg_t_10 {
  margin-top: 10px;
  position: relative;
}
.crm-color-name {
  position: absolute;
  margin-left: 10px;
  font-size: 14px;
}

.radio-group-skin.el-radio-group {
  .el-radio {
    margin-right: 0;
    ::v-deep &.is-checked {
      .el-radio__inner:after {
        content: "";
        position: absolute;
        top: 4px;
        left: 10px;
        width: 10px;
        height: 18px;
        border-radius: 0;
        background-color: transparent;
        border-color: #fff;
        border-style: solid;
        border-width: 0 2px 3px 0;
        transform: rotate(45deg);
      }
    }
    &.blue {
      ::v-deep .el-radio__input {
        .el-radio__inner,
        .el-radio__inner:after {
          background-color: #2db7f5;
        }
      }
    }
    &.green {
      ::v-deep .el-radio__input {
        .el-radio__inner,
        .el-radio__inner:after {
          background-color: #67c23a;
        }
      }
    }
    &.pink {
      ::v-deep .el-radio__input {
        .el-radio__inner,
        .el-radio__inner:after {
          background-color: #f56c6c;
        }
      }
    }
    &.yellow {
      ::v-deep .el-radio__input {
        .el-radio__inner,
        .el-radio__inner:after {
          background-color: #ffa902;
        }
      }
    }
    &.skyblue {
      ::v-deep .el-radio__input {
        .el-radio__inner,
        .el-radio__inner:after {
          background-color: #00cccd;
        }
      }
    }
    &.lime {
      ::v-deep .el-radio__input {
        .el-radio__inner,
        .el-radio__inner:after {
          background-color: #aace06;
        }
      }
    }
    &.hotpink {
      ::v-deep .el-radio__input {
        .el-radio__inner,
        .el-radio__inner:after {
          background-color: #e03e74;
        }
      }
    }

    ::v-deep .el-radio__label {
      display: none;
    }
    ::v-deep .el-radio__input {
      margin-right: 10px;
      .el-radio__inner {
        display: inline-block;
        position: relative;
        border: 1px solid #dcdfe6;
        border-radius: 2px;
        box-sizing: border-box;
        width: 30px;
        height: 30px;
        border: none;
      }
    }
  }
}
.radio-border {
  ::v-deep &:after {
    content: "";
    display: block;
    border: 1px solid #fff;
    border-left: 0;
    border-top: 0;
    height: 16px;
    left: 4px;
    position: absolute;
    top: 1px;
    transform: rotate(45deg) scaleY(0);
    width: 16px;
  }
  ::v-deep .el-radio {
    &.is-bordered {
      margin-right: 8px;
      border-color: transparent;
      line-height: 0.8;
      border-radius: 0;
      padding: 2px;
      height: auto;
      & + .is-bordered {
        margin-left: 0;
      }
      .el-radio__label {
        padding-left: 0;
      }
      .el-radio__inner {
        background-color: transparent;
        border-color: transparent;
      }
    }
    &.is-checked {
      border-color: #337eff;

      .el-radio__inner {
        background-color: #337eff;
        &:after {
          content: "";
          position: absolute;
          top: 3px;
          left: 5px;
          width: 5px;
          height: 9px;
          border-radius: 0;
          background-color: transparent;
          border-color: #fff;
          border-style: solid;
          border-width: 0 1px 2px 0;
          transform: rotate(45deg);
        }
      }
    }
  }
  ::v-deep .el-radio__input {
    /*display: none;*/
    position: absolute;
    top: -6px;
    right: -6px;
    width: 16px;
    height: 16px;
    border-radius: 50%;
  }
  &.is-checked {
    position: relative;
    ::v-deep &:after {
      background-color: #337eff;
      transform: rotate(45deg) scaleY(1);
    }
  }
}

.avatarImgCls {
  width: 100px;
  height: 100px;
  display: block;
}
</style>
